import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "dropdown w-100",
  ref: "dropdown"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "message-container text-start" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "content"
}
const _hoisted_6 = {
  key: 0,
  class: "border-bottom p-1 ps-2 title text-muted"
}
const _hoisted_7 = {
  key: 1,
  class: "py-1 d-flex justify-content-between border-bottom text-primary cursor-pointer"
}
const _hoisted_8 = { class: "form-check custom-checkbox" }
const _hoisted_9 = ["id", "value", "onChange", "checked", "disabled"]
const _hoisted_10 = ["for"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`w-100 input-group multiselect-dropdown ${_ctx.findAMatch ? 'ai-border' : ''}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("button", {
        class: _normalizeClass(`btn border bg-white dropdown-toggle ${_ctx.disabled ? 'disabled' : ''} w-100`),
        type: "button",
        "data-bs-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        disabled: _ctx.disabled
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.message), 1 /* TEXT */)
      ], 10 /* CLASS, PROPS */, _hoisted_2), [
        [_vShow, !_ctx.hasCustomView]
      ]),
      _withDirectives(_createElementVNode("button", {
        class: _normalizeClass(`btn btn-custom px-2 ${_ctx.isActive ? _ctx.activeClasses : 'text-muted'}`),
        "data-bs-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        disabled: _ctx.disabled,
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleActiveClasses(true)))
      }, [
        _renderSlot(_ctx.$slots, "custom-view")
      ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_4), [
        [_vShow, _ctx.hasCustomView]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(`dropdown-menu p-0 ${_ctx.findAMatch ? 'ai-drop-menu' : ''}`),
        ref: "dropdownElement"
      }, [
        (_ctx.options && _ctx.options.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.title.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.title), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.hasActions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      class: "ps-3 text-decoration",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAll()))
                    }, " Check all "),
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      class: "pe-2 text-decoration",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deselectAll()))
                    }, " Uncheck all ")
                  ]))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "dropdown-item ps-3",
                  key: item.value
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: `${_ctx.name}option${item.value}${index}`,
                      value: item.value,
                      onChange: ($event: any) => (_ctx.updateSelectedItems(item.value, $event)),
                      checked: _ctx.selectedItem(item.value),
                      disabled: _ctx.disabled
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9),
                    _createElementVNode("label", {
                      class: "fw-light form-check-label",
                      for: `${_ctx.name}option${item.value}${index}`
                    }, [
                      (_ctx.showIcons)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            innerHTML: _ctx.getView(item)
                          }, null, 8 /* PROPS */, _hoisted_11))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("span", {
                        class: "label-content",
                        title: `${item.name}`
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_12)
                    ], 8 /* PROPS */, _hoisted_10)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ], 512 /* NEED_PATCH */)
  ], 2 /* CLASS */))
}